/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Onboarding_Resume_Created_With_NameInputs */

const en_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resume created: ${i?.name}`)
};

const de_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lebenslauf erstellt: ${i?.name}`)
};

const fr_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CV créé : ${i?.name}`)
};

const es_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Currículum creado: ${i?.name}`)
};

const it_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Curriculum creato: ${i?.name}`)
};

const nl_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CV gemaakt: ${i?.name}`)
};

const pl_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CV utworzone: ${i?.name}`)
};

const fi_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ansioluettelo luotu: ${i?.name}`)
};

const da_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CV oprettet: ${i?.name}`)
};

const sv_onboarding_resume_created_with_name = /** @type {(inputs: Onboarding_Resume_Created_With_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CV skapat: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Resume created: {name}" |
*
* @param {Onboarding_Resume_Created_With_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_created_with_name = /** @type {((inputs: Onboarding_Resume_Created_With_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_Created_With_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_created_with_name(inputs)
	if (locale === "fr") return fr_onboarding_resume_created_with_name(inputs)
	if (locale === "es") return es_onboarding_resume_created_with_name(inputs)
	if (locale === "it") return it_onboarding_resume_created_with_name(inputs)
	if (locale === "nl") return nl_onboarding_resume_created_with_name(inputs)
	if (locale === "pl") return pl_onboarding_resume_created_with_name(inputs)
	if (locale === "fi") return fi_onboarding_resume_created_with_name(inputs)
	if (locale === "da") return da_onboarding_resume_created_with_name(inputs)
	if (locale === "sv") return sv_onboarding_resume_created_with_name(inputs)
	return en_onboarding_resume_created_with_name(inputs)
});